// extracted by mini-css-extract-plugin
module.exports = {"container":"_88e3da3","skeleton":"_f9ce417","textSkeleton":"_c58f1fd","dropdownSection":"_226012a","title":"_528c736"};